import type { ReactElement } from "react";
import type { FunnelSection } from "./developers-funnel-content";
import { DevelopersGrowthChart } from "./developers-growth-chart";

/**
 * Getting-started band: copy left, chart right on desktop.
 */
export function DevelopersGrowthSplitSection({
  section,
}: {
  readonly section: FunnelSection;
}): ReactElement {
  return (
    <section
      id={section.id}
      className="dvf-section dvf-section-embed dvf-section-alt"
    >
      <div className="dvf-section-inner">
        <div className="dvf-section-grid">
          <div className="dvf-section-media dvf-growth-split-media">
            <DevelopersGrowthChart clipId="dvf-growth-reveal-split" />
          </div>
          <div>
            <h2 className="dvf-section-title">{section.heading}</h2>
            {section.intro ? (
              <p className="dvf-section-intro">{section.intro}</p>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}
